import api from "../utils/api.js";

export const search = {
    namespaced: true,
    state: {
        searchOpen: false,
        searchResult: {
            total: 0,
            products: [],
        },
        productBrands: [],
        featuredCollections: [],
    },
    getters: {
        searchOpen(state) {
            return state.searchOpen;
        },
        searchResult(state) {
            return state.searchResult;
        },
        productBrands(state) {
            return state.productBrands;
        },
        featuredCollections(state) {
            return state.featuredCollections;
        },
    },
    mutations: {
        setSearchOpen(state, payload) {
            state.searchOpen = payload.searchOpen;
        },
        toggleSearchOpen(state, payload) {
            state.searchOpen = !state.searchOpen;
        },
        setSearchResult(state, payload) {
            if (payload.total.value > -1) {
                payload.total = payload.total.value;
            }
            state.searchResult = payload;
        },
        setProductBrands(state, payload) {
            state.productBrands = payload;
        },
        setFeaturedCollections(state, payload) {
            state.featuredCollections = payload;
        },
    },
    actions: {
        performSearch(context, payload) {
            const uri = api.searchUri();
            return api
                .get(uri, {
                    params: {
                        q: payload.query,
                        p: payload.page,
                        brand: payload.brand,
                        sort: payload.sort,
                    },
                })
                .then((response) => {
                    if (payload.page > 1) {
                        context.commit("setSearchResult", {
                            total: response.total,
                            products: [...context.state.searchResult.products, ...response.products],
                        });
                    } else {
                        context.commit("setSearchResult", response);
                    }

                    return response.products;
                })
                .catch((error) => {
                    return Promise.reject(error);
                });
        },
        loadBrands(context) {
            const uri = api.brandsUri();
            return api
                .get(uri)
                .then((response) => {
                    context.commit("setProductBrands", response.brands);
                })
                .catch((error) => {
                    return Promise.reject(error);
                });
        },
        loadFeaturedCollections(context) {
            const uri = api.collectionsUri();
            return api
                .get(uri + "featured")
                .then((response) => {
                    context.commit("setFeaturedCollections", response.data);
                })
                .catch((error) => {
                    return Promise.reject(error);
                });
        },
        getProduct(context, payload) {
            let uri = api.productsUri();
            return api
                .get(uri + payload.id)
                .then((response) => {
                    return response;
                })
                .catch((error) => {});
        },
    },
};
